export const all = [
  {
    Header: 'RFQ Description',
    accessor: 'description',
  },
  {
    Header: 'Modified By',
    accessor: 'email',
  },

  {
    Header: 'Created',
    accessor: 'rfqCreateDate',
  },
  {
    Header: 'Modified Date',
    accessor: 'modified',
  },
  {
    Header: 'Quote Due Date',
    accessor: 'quoteDueDate',
  },
  {
    Header: 'RFQ Status',
    accessor: 'status',
  },
  {
    Header: 'Awardee',
    accessor: 'companyName',
  },
  {
    Header: 'Awarded Date',
    accessor: 'awardDate',
  },
  {
    Header: 'Archived Date',
    accessor: 'archiveDate',
  },
];

export const drafts = [
  {
    Header: 'RFQ Description',
    accessor: 'description',
  },
  {
    Header: 'Part Number',
    accessor: 'partNum',
  },
  {
    Header: 'Part Description',
    accessor: 'partDesc',
  },
  {
    Header: 'Solicitation #',
    accessor: 'solNum',
  },
  {
    Header: 'NIIN/NSN',
    accessor: 'niin',
  },

  {
    Header: 'Modified By',
    accessor: 'email',
  },
  {
    Header: 'Quote Due Date',
    accessor: 'quoteDueDate',
  },
  {
    Header: 'Modified Date',
    accessor: 'modified',
  },
  {
    Header: 'RFQ Status',
    accessor: 'status',
  },
];

export const submitted = [
  {
    Header: 'RFQ Description',
    accessor: 'description',
  },
  {
    Header: 'Part Number',
    accessor: 'partNum',
  },
  {
    Header: 'Part Description',
    accessor: 'partDesc',
  },
  {
    Header: 'Solicitation #',
    accessor: 'solNum',
  },
  {
    Header: 'NIIN/NSN',
    accessor: 'niin',
  },
  {
    Header: 'Modified By',
    accessor: 'email',
  },
  {
    Header: 'Quote Due Date',
    accessor: 'quoteDueDate',
  },
  {
    Header: 'Modified Date',
    accessor: 'modified',
  },
  {
    Header: 'RFQ Status',
    accessor: 'status',
  },
];

export const rfr = [
  {
    Header: 'RFQ Description',
    accessor: 'description',
  },
  {
    Header: 'Part Number',
    accessor: 'partNum',
  },
  {
    Header: 'Part Description',
    accessor: 'partDesc',
  },
  {
    Header: 'Solicitation #',
    accessor: 'solNum',
  },
  {
    Header: 'NIIN/NSN',
    accessor: 'niin',
  },
  {
    Header: 'Modified By',
    accessor: 'email',
  },
  {
    Header: 'Quote Due Date',
    accessor: 'quoteDueDate',
  },
  {
    Header: 'Modified Date',
    accessor: 'modified',
  },
  {
    Header: 'RFQ Status',
    accessor: 'status',
  },
];

// archiveDate: null
// awardDate: null
// companyName: null
// description: "New RFQ"
// email: "test@test.com"
// modified: "2020-09-29"
// niin: null
// partDesc: null
// partNum: null
// quoteDueDate: null
// rfqCreateDate: "2020-08-19"
// rfqId: 2
// solNum: null
// status: "Draft"

export const awarded = [
  {
    Header: 'RFQ Description',
    accessor: 'description',
  },
  {
    Header: 'Part Number',
    accessor: 'partNum',
  },
  {
    Header: 'Part Description',
    accessor: 'partDesc',
  },
  {
    Header: 'Solicitation #',
    accessor: 'solNum',
  },
  {
    Header: 'NIIN/NSN',
    accessor: 'niin',
  },
  {
    Header: 'Modified By',
    accessor: 'email',
  },

  {
    Header: 'Created',
    accessor: 'rfqCreateDate',
  },
  {
    Header: 'Modified Date',
    accessor: 'modified',
  },

  {
    Header: 'Awardee',
    accessor: 'companyName',
  },
  {
    Header: 'Awarded Date',
    accessor: 'awardDate',
  },
];

export const archived = [
  {
    Header: 'RFQ Description',
    accessor: 'description',
  },
  {
    Header: 'Modified By',
    accessor: 'email',
  },

  {
    Header: 'Created',
    accessor: 'rfqCreateDate',
  },
  {
    Header: 'Modified Date',
    accessor: 'modified',
  },

  {
    Header: 'RFQ Status',
    accessor: 'status',
  },

  {
    Header: 'Archived Date',
    accessor: 'archiveDate',
  },
];



// WEBPACK FOOTER //
// ./src/pages/ContractCenter/ColumnGrids/RFQColumns.jsx